import $http from '@/plugins/axios'
import AppService from "src/services/app.service";
import utils from "@/services/utils";

const ReportService = {
    SessionInfo(botCode, supporterEmail,timeType, fromDate, toDate, page=null, page_size=null) {
        if (supporterEmail && supporterEmail !== '') {
            return $http.get(`/live-support/session-report/${botCode}/${fromDate}/${toDate}/?supporter_email=${supporterEmail}&time_type=${timeType}&page=${page}&page_size=${page_size}`)
        } else {
            return $http.get(`/live-support/session-report/${botCode}/${fromDate}/${toDate}/?time_type=${timeType}&page=${page}&page_size=${page_size}`)
        }
    },
    SessionInfoExcel(botCode, supporterEmail,timeType, fromDate, toDate, crmExportFields, customerAttributes) {
        let body = {
            crm_export_fields: crmExportFields,
            customer_attributes: customerAttributes
        }
        if (supporterEmail && supporterEmail !== '') {
            return $http.post(`/live-support/session-report-excel/${botCode}/${fromDate}/${toDate}/?supporter_email=${supporterEmail}&time_type=${timeType}`, body)
        } else {
            return $http.post(`/live-support/session-report-excel/${botCode}/${fromDate}/${toDate}/?time_type=${timeType}`, body)
        }
    },
    SenderExcel(botCode, properties, customerAttributes, fromDate, toDate) {
        let body = {
            properties: properties,
            customer_attributes: customerAttributes,

        }
        return $http.post(`/live-support/sender-report-excel/${botCode}/${fromDate}/${toDate}`, body)
        
    },
    //SLA report
    getSLAList(bot_code, agent_email , duration, fromDate, toDate, page, page_size, sortBy, descending ) {
        let query = utils.buildSLAQuery (agent_email, duration, fromDate, toDate, page, page_size, sortBy, descending)

        return $http.get(`/live-support/agent-sla/${bot_code}/overdue/list?${query}`)
    },
    SLAExcel(botCode, agent_email, duration,  fromDate, toDate, sortBy, descending) {
        let query = utils.buildSLAQuery(agent_email, duration, fromDate, toDate, null, null, sortBy, descending)

        return $http.get(`/live-support/agent-sla/${botCode}/overdue/export?${query}`)
        
    },
    SessionReportStatus(botCode) {
        return $http.get(`/live-support/session-report-status/${botCode}/`)
    },
    Categories(botCode) {
        return $http.get(`/live-support/report-categories/${botCode}/`)
    },
    Overview(botCode, channel, skills, fromDate, toDate) {
        let timeQuery = AppService.buildTimeQuery(fromDate, toDate);
        if (channel) {
            return $http.get(`/live-support/overview-report/${botCode}?channel=${channel}&skills=${skills}&${timeQuery}`)
        }
        else {
            return $http.get(`/live-support/overview-report/${botCode}?skills=${skills}&${timeQuery}`)
        }
    },
    MissChat(botCode, channel, skills, fromDate, toDate) {
        let timeQuery = AppService.buildTimeQuery(fromDate, toDate);
        if (channel) {
            return $http.get(`/live-support/miss-chat-report/${botCode}?channel=${channel}&skills=${skills}&${timeQuery}`)
        }
        else {
            return $http.get(`/live-support/miss-chat-report/${botCode}?skills=${skills}&${timeQuery}`)
        }
    },
    Ticket(botCode, status, keyword, fromDate, toDate, page=null, page_size=null) {
        let query = `page=${page}&page_size=${page_size}`;
        if (status && status !== '') {
            query = query + `&status=${status}`
        }
        if (keyword && keyword !=='') {
            query = query + `&keyword=${keyword}`
        }
        return $http.get(`/live-support/ticket-report/${botCode}/${fromDate}/${toDate}/?${query}`)
    },
    TicketReportExcel(botCode, status, keyword, fromDate, toDate) {
        let query = "";
        if (status && status !== '') {
            query = query + `&status=${status}`
        }
        if (keyword && keyword !=='') {
            query = query + `&keyword=${keyword}`
        }
        return $http.get(`/live-support/ticket-report-excel/${botCode}/${fromDate}/${toDate}/?${query}`)
    },
    TicketReportStatus(botCode) {
        return $http.get(`/live-support/ticket-report-status/${botCode}/`)
    },
    agentMonitorExcel(botCode,fromDate, toDate){
        let query = ''
        if (fromDate && toDate) {
            query = query + '&fromDate=' + fromDate.toISOString() + '&toDate=' + toDate.toISOString()
        }
        return $http.get(`/live-support/agent-status-log/${botCode}/export?${query}`)

    },
    getAgentStatusLog(botCode, fromDate, toDate, page=1, page_size=10) {
        let query = ''
        if (page) {
            query = query + '&page=' + page
        }
        if (page_size) {
            query = query + '&page_size=' + page_size
        }
        if (fromDate && toDate) {
            query = query + '&fromDate=' + fromDate.toISOString() + '&toDate=' + toDate.toISOString()
        }
        return $http.get(`/live-support/agent-status-log/${botCode}/list?${query}`)
    },
}

export default ReportService
